import { render } from "./ProductsEdit.vue?vue&type=template&id=0bbc2a8c&scoped=true"
import script from "./ProductsEdit.vue?vue&type=script&lang=js"
export * from "./ProductsEdit.vue?vue&type=script&lang=js"

import "./ProductsEdit.vue?vue&type=style&index=0&id=0bbc2a8c&lang=css"
import "./ProductsEdit.vue?vue&type=style&index=1&id=0bbc2a8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbc2a8c"]])

export default __exports__